import colors from "../../../../../../Constants/colors";

export const tableContainerStyles = {
  overflowY: "scroll",
  width: "100%",
  "&::-webkit-scrollbar": {
    width: "12px",
    height: "12px",
  },
  "&::-webkit-scrollbar-thumb": {
    display: "none",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: colors.primaryBlue,
    borderRadius: "10px",
  },
  scrollbarWidth: "thin",
  scrollbarColor: `${colors.primaryBlue} ${colors.secondaryBlue}`,
  backgroundColor: colors.extremeBlack,
  boxShadow: `0px 0px 80px ${colors.secondaryBlue}`,
  marginTop: "20px",
  paddingBottom: "20px",
  overflowX: "auto",
  borderRadius: 2,
};

export const tableCellStyleHeader = {
  color: colors.extremeWhite,
  fontWeight: "bold",
  bgcolor: colors.primaryBlue,
  whiteSpace: "nowrap",
  padding: "4px",
};

export const textfieldLayout = {
  mr: 2,
  borderRadius: "8px",
  "& .MuiOutlinedInput-root": {
    padding: "1px 7px", // Adjust padding to reduce height
    fontSize: "0.875rem", // Adjust font size

    "&.Mui-disabled": {
      backgroundColor: colors.darkGray,
      color: colors.lightGray,
    },
  },
  input: {
    "&.Mui-disabled": {
      color: colors.lightGray,
    },
  },
};

export const tableCellStyleBody = {
  bgcolor: colors.darkGray,
  color: colors.extremeWhite,
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  padding: "8px",
};

export const selectBaseStyles = {
  backgroundColor: colors.extremeWhite,
  border: `1px solid ${colors.primaryBlue}`,
  borderRadius: "5px",
  // boxShadow: `0px 4px 12px ${colors.secondaryBlue}`,
  color: colors.extremeBlack,
  "& .MuiSelect-icon": {
    color: colors.extremeBlack,
  },
  "& .MuiInputBase-input": {
    color: colors.extremeBlack,
  },
  "& .Mui-focused .MuiInputLabel-root": {
    color: colors.extremeBlack,
  },
  "&:before, &:after": {
    border: `1px solid ${colors.primaryBlue}`,
  },
};

export const menuItemStyles = {
  backgroundColor: "transparent",
  color: colors.extremeWhite,
  fontWeight: "normal",
  "&:hover": {
    backgroundColor: colors.primaryBlue,
    color: colors.extremeWhite,
  },
  "&.Mui-selected": {
    backgroundColor: `${colors.secondaryBlue} !important`,
    color: `${colors.extremeWhite} !important`,
    "&:hover": {
      backgroundColor: `${colors.primaryBlue} !important`,
      color: `${colors.extremeWhite} !important`,
    },
  },
};

export const menuContainerStyles = {
  backgroundColor: colors.extremeBlue,
  // boxShadow: `0px 4px 12px ${colors.primaryBlue}`,
  opacity: 1,
  backdropFilter: "none",
};

export const toggleButtonsStyles = {
  color: colors.extremeWhite,
  bgcolor: colors.primaryBlue,
  "&.Mui-selected": {
    bgcolor: colors.secondaryBlue,
    color: colors.extremeWhite,
    fontWeight: "bold",
    "&:hover": {
      bgcolor: colors.secondaryBlue,
    },
  },
  "&:hover": {
    bgcolor: colors.secondaryBlue,
  },
};

export const btnStyles = {
  color: colors.extremeWhite,
  bgcolor: colors.primaryBlue,
  textTransform: "none",
  ":hover": {
    bgcolor: colors.secondaryBlue,
  },
};

export const inputStyles = {
  color: colors.extremeWhite,
  backgroundColor: colors.textFieldBackground,
  padding: "1px 10px",
  marginTop: "10px",
  outline: `1px solid ${colors.extremeWhite}`,
  borderRadius: "5px",
};

export const labelStyles = {
  color: colors.extremeWhite,
  lineHeight: "2px",
  paddingBottom: "2px",
  marginBottom: "0px",
  marginLeft: "2px",
};

export const textfieldLayoutPrompt = {
  backgroundColor: colors.extremeWhite,
  borderRadius: "5px",
  // boxShadow: "0px 4px 12px var(--secondaryBlue)",
  "& .MuiInputBase-input": {
    color: colors.extremeBlack, // Ensure the text color inside the input is white
  },
  "& .MuiInputLabel-root.Mui-focused": {
    fontSize: "1.25rem",
    color: colors.extremeBlack,
  },
  "& .MuiInputLabel-root": {
    color: colors.extremeBlack,
  },
  border: `1px solid ${colors.primaryBlue}`,
};
